type HistoryAmount = { amount: number; payout: number; result: string };

export function settledBetNet(bet: HistoryAmount): number {
  return bet.result === 'pending' ? 0 : bet.payout - bet.amount;
}

export function historyTotals(bets: HistoryAmount[]) {
  return bets.reduce((total, bet) => ({
    stake: total.stake + bet.amount,
    returned: total.returned + (bet.result === 'pending' ? 0 : bet.payout),
    net: total.net + settledBetNet(bet),
  }), { stake: 0, returned: 0, net: 0 });
}
